{
  "general": {
    "title": "Comparar opções",
    "intro": "Uma visão rápida sobre a diferença entre Comunidade, Assinatura e Compra Única.",
    "tableheader": "Assinatura",
    "note1": "* Opções de compra em grupo e desconto por volume disponíveis.",
    "note2": "** Idiomas aceitos Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Requer uma conta gratuita da comunidade myboardmaker.com e destina-se apenas ao armazenamento de atividades."
  },
  "columnHeadings": {
    "community": "COMUNIDADE",
    "onetime": "COMPRA ÚNICA*",
    "personal": "PESSOAL",
    "professional": "PROFISSIONAL",
    "organization": "ORGANIZAÇÃO*"
  },
  "mobileHeadings": {
    "community": "Comunidade",
    "onetime": "Compra Única*",
    "personal": "Pessoal",
    "professional": "Profissional",
    "organization": "Compra Única*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Ativações",
    "languages": "Idiomas**",
    "licensing": "Licença",
    "pcsSymbols": "PCS Symbols",
    "templates": "Modelos",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Fazer atividades como instrutor",
    "playActivitiesStudent": "Fazer atividades como aluno",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Gerenciamento do professor",
    "studentManagement": "Gerenciador de alunos",
    "assignStudentActivities": "Atribuir atividades do aluno",
    "cloudStorage": "Armazenamento em nuvem",
    "createAndJoin": "Criar e participar de grupos",
    "accessCommunity": "Acesso a mais de 120 mil atividades comunitárias",
    "shareActivity": "Compartilhe atividades na comunidade",
    "curriculum": "Currículo e conteúdo",
    "activitiesToGo": "Atividades práticas do Boardmaker",
    "instructionalSolutions": "Soluções instrucionais",
    "premiumActivities": "Atividades Premium",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 dispositivos",
    "unlimited": "Ilimitado",
    "byKey": "Chave Licença",
    "symbols": "Mais de 80.000",
    "templates": "Mais de 600",
    "languages": "12",
    "login": "Entrar",
    "yes": "Sim",
    "yesNote": "Sim***",
    "no": "Não"
  }
}